__turbopack_context__.v({
  "company-card": "company-listing-page-content-client-module-scss-module__uZ0kpG__company-card",
  "error-message": "company-listing-page-content-client-module-scss-module__uZ0kpG__error-message",
  "filters": "company-listing-page-content-client-module-scss-module__uZ0kpG__filters",
  "filters__form": "company-listing-page-content-client-module-scss-module__uZ0kpG__filters__form",
  "listing-page-content": "company-listing-page-content-client-module-scss-module__uZ0kpG__listing-page-content",
  "no-results-message": "company-listing-page-content-client-module-scss-module__uZ0kpG__no-results-message",
  "table-loader": "company-listing-page-content-client-module-scss-module__uZ0kpG__table-loader",
});
